<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.cdnStatus"
        placeholder="生效状态"
      >
        <el-option
          v-for="(item, i) in cdnList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
      >
        <el-option
          v-for="(item, i) in onlineList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn" v-if="isShowDeptLevel">
      <el-select
        class="select_btn_style"
        v-model="filters.deptLevelCodeQuery"
        placeholder="所属学院"
      >
        <el-option
          v-for="(item, i) in deptList"
          :key="i"
          :label="item.deptName"
          :value="item.deptLevelCode"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="视频名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import { collegeSimpleFullList } from "@/api/dept";
import butn from "@/components/button/index";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {
        displayClientTypes: [],

      },
      onlineList: [],
      typeList: [],
      cdnList: [],
      deptList: [],
    };
  },
  props: {
    isShowDeptLevel: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    
    collegeSimpleFullList().then(res => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        deptLevelCode: "",
        deptName: "全部",
      });
      this.deptList = res.data;
    });
    this.getSysParamByTypes(["CDN_STATUS", "ONLINE_STATUS", "DISPLAY_CLIENT_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["CDN_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.onlineList = res.data["ONLINE_STATUS"] || [];
        this.cdnList = res.data["CDN_STATUS"] || [];
        this.typeList = res.data["DISPLAY_CLIENT_TYPE"] || [];
      });
    },
    initData() {
      if (this.filters.displayClientTypes.includes("")) {
        delete this.filters.displayClientTypes;
        this.$emit("search", { ...this.filters });
        return;
      }

      this.$emit("search", { ...this.filters });
    },
    resetData() {
      this.filters = {
        displayClientTypes: []
      };
      this.$emit("search", { ...this.filters });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
